<template>
<div class="app-container">
  <el-footer class="footer">
      {{$t('lang.footer.version')}}
      <a target="_blank" href="javascript:void(0)" class="link">{{$t('lang.footer.owner')}}</a>
  </el-footer>
</div>
</template>

<script>
export default {
  name: 'foot',
  data() {
    return {}
  },
  methods: {}
}
</script>

<style>
.footer {
    background-color: #1b1f40;
    line-height: 60px;
    text-align: center;
    color: #606266;
}
.link{
  text-align: center;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue